var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrescriptionicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 6.41667H15.5833V5.5C15.5833 4.77065 15.2936 4.07118 14.7779 3.55546C14.2622 3.03973 13.5627 2.75 12.8333 2.75H9.16667C8.43732 2.75 7.73785 3.03973 7.22212 3.55546C6.7064 4.07118 6.41667 4.77065 6.41667 5.5V6.41667H4.58333C4.09755 6.41812 3.63208 6.61174 3.28857 6.95524C2.94507 7.29874 2.75145 7.76422 2.75 8.25V17.4167C2.75145 17.9025 2.94507 18.3679 3.28857 18.7114C3.63208 19.0549 4.09755 19.2486 4.58333 19.25H17.4167C17.9025 19.2486 18.3679 19.0549 18.7114 18.7114C19.0549 18.3679 19.2486 17.9025 19.25 17.4167V8.25C19.2486 7.76422 19.0549 7.29874 18.7114 6.95524C18.3679 6.61174 17.9025 6.41812 17.4167 6.41667ZM8.25 5.5C8.25 5.25688 8.34658 5.02373 8.51849 4.85182C8.69039 4.67991 8.92355 4.58333 9.16667 4.58333H12.8333C13.0764 4.58333 13.3096 4.67991 13.4815 4.85182C13.6534 5.02373 13.75 5.25688 13.75 5.5V6.41667H8.25V5.5ZM13.75 13.75H11.9167V15.5833H10.0833V13.75H8.25V11.9167H10.0833V10.0833H11.9167V11.9167H13.75V13.75Z",
    fill: "#818194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptionicon);
export default __webpack_public_path__ + "static/media/Prescriptionicon.aa52cd73c286ba7e1b1038c370c5437a.svg";
export { ForwardRef as ReactComponent };